import styled from "styled-components"
import { Toggle, Input } from 'linkdrop-ui'

export const InputStyled = styled(Input)`

`